<template>
  <el-container class="main-con">
    <el-header>
      <el-input placeholder="搜索机构名称、省份、城市、地址" v-model="searchParam.keywords" class="input-with-select">
        <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
      </el-input>
      <el-button type="primary" class="add-student theme-btn" @click="checkAdd">新增机构</el-button>
    </el-header>
    <el-main>
      <el-table :data="tableData">
        <el-table-column prop="name" label="机构名称" align="center"></el-table-column>
        <el-table-column prop="contact" label="管理员" align="center"></el-table-column>
        <el-table-column prop="userNum" label="学生人数" align="center"></el-table-column>
        <el-table-column prop="province" label="省份" align="center"></el-table-column>
        <el-table-column prop="city" label="城市" align="center"></el-table-column>
        <el-table-column prop="priv" label="乐器权限" align="center"></el-table-column>
        <el-table-column prop="expireDate" label="账户有效期" style="text-align: center" align="center"></el-table-column>
        <el-table-column prop="isAgent" label="承办单位" align="center">
          <template v-slot="scope">
              <p v-if="scope.row.isAgent===1">是</p>
              <p v-else>否</p>
          </template>
        </el-table-column>
        <el-table-column prop="validity" label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button size="mini"  class="no-border" type="primary" plain @click="checkDetail(scope.$index, scope.row)">查看</el-button>
            <el-button size="mini" class="theme-btn" plain @click="edit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" v-if="scope.row.status === 1" @click="stopUse(scope.$index, scope.row)">停用</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.status === 0"  @click="startUse(scope.$index, scope.row)">启用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <common-pagination @paginationSearch="paginationSearch" :pages="pages"></common-pagination>
    </el-main>
  </el-container>
</template>

<script>
  import Pagination from "../common/Pagination"

  export default {
    name: "OrganList",
    props: ['pageRight'],
    components: {
      commonPagination: Pagination,
    },
    data() {
      return {
        // 获取列表数据
        tableData: [],
        //  搜索条件
        search: "",
        //  查询条件
        searchParam: {
          keywords: "",  // 关键字 关键字，如机构名，省份，城市、地址等
          pageNum: 1,   // 页数
          pageSize: 10,  // 每页大小
        },
        //   总页数
        pages: 0,
      }
    },
    created() {
      // 获取列表数据
      this.getDataList()
    },
    destroyed() {
      console.log('离开列表页，如有停用操作发生，记得保存数据喔~')
    },
    methods: {
      // 获取数据
      getDataList() {

        // 请求参数 keywords  pageNum  pageSize

        // this.$api.get('/customer/list.json',param); // 返回的是一个promise


        this.$api.get('/customer/list.json', this.searchParam)
          .then(res => { // 成功才会有数据
            this.tableData = res.data.list;
            console.log(this.tableData);
            this.pages = res.data.pages
          }, err => {
            this.$message.error(err.msg);
          })
          .catch(err => {
            console.log(err);
            this.$message.error('数据请求异常！');
          });

      },

      // 搜索
      searchData() {
        // 每次搜索都显示第一页
        this.searchParam.pageNum=1;
        this.getDataList()
      },
      // 分页搜索
      paginationSearch(pageNum){
        this.searchParam.pageNum=pageNum;
        this.getDataList()
      },

      // 新增机构
      checkAdd(){
        this.$emit('checkAddOrgan')
      },

      // 查看详情
      checkDetail(index, row) {
        console.log(index, row); // 详情页根据id获取详细信息  将指令抛出给父组件  父组件显示内容
        this.$emit('checkDetail', row)
      },
      // 编辑
      edit(index, row) {
        // 显示新增页
        this.$emit('showEdit', row)
      },
      // 停用
      stopUse(index, row) {
        let param ={
          id:row.id
        };
        this.$api.put('/customer/disable.json',param)
          .then(res => { // 成功才会有数据
            this.$message({
              message: '停用成功!',
              type: 'success'
            });
            this.tableData[index].status = 0;
          }, err => {
            this.$message.error(err.msg);
          })
          .catch(err => {
            console.log(err);
            this.$message.error('停用异常！');
          });

      },
      //启用
      startUse(index, row){
        // console.log(row.status);
        let param ={
          id:row.id
        };
        this.$api.put('/customer/enable.json',param)
          .then(res => { // 成功才会有数据
            this.$message({
              message: '启用成功!',
              type: 'success'
            });
            this.tableData[index].status = 1;
          }, err => {
            this.$message.error(err.msg);
          })
          .catch(err => {
            console.log(err);
            this.$message.error('启用异常！');
          });

      }

    }
  }
</script>

<style scoped>
  /*s搜索区*/

  .el-header {
    /*padding-top: 10px;*/
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
  }
  .el-main{
    background-color: #f2f6f9;
    padding-right: 0;
    padding-left: 0;
  }

  .input-with-select {
    width: 300px;
  }

  .add-student {
    margin-left: 200px;
    border: 0;
    box-shadow: none;
  }

  /*.search-btn{*/
    /*border: #f3cd04 1px solid;*/
  /*}*/
  /*搜索区结束*/

</style>



// WEBPACK FOOTER //
// src/components/organManage/OrganList.vue